const age = [
    { type: 'required', message: 'Age is required' },
    { type: 'pattern', message: 'Your name must contain only numbers' },
    // { type: 'validFirstname', message: 'Your name has already been taken' },
    // { type: 'areEqual', message: 'You entered wrong username' },
]

export default { age };